<div class="auth-card">
  <div class="dx-card content">
    <div class="logo">
      <img src="assets/midstate_logo.webp" alt="MidState Logo" />
    </div>
      <div class="header">
      <div class="title">{{ title }}</div>
      <div class="description">{{ description }}</div>
    </div>
    <ng-content></ng-content>
  </div>
</div>
